import '../styles/components/WhyChooseUs.css';
import { m } from 'framer-motion';
import { fadeUp, staggerContainer, staggerItem, viewport } from '../motion/variants';

const reasons = [
  {
    title: 'Quality Construction Materials',
    description:
      'We supply durable and high-quality construction materials that meet industry standards for residential, commercial, and infrastructure projects.',
  },
  {
    title: 'Reliable Delivery Services',
    description:
      'Our logistics and transport team ensures timely and safe delivery of materials to project sites across Tanzania.',
  },
  {
    title: 'Competitive Pricing',
    description:
      'We provide affordable pricing without compromising quality, helping clients manage project costs effectively.',
  },
  {
    title: 'Professional & Trusted Service',
    description:
      'We are committed to professionalism, transparency, and customer satisfaction in every project we support.',
  },
  {
    title: 'Consistent Supply Capacity',
    description:
      'We maintain a reliable supply chain to ensure uninterrupted availability of construction materials for projects of all sizes.',
  },
  {
    title: 'Customer-Centered Approach',
    description:
      'We work closely with our clients to understand their project needs and provide tailored construction support solutions.',
  },
];

function WhyChooseUs() {
  return (
    <section className="why" id="why-choose-us">
      <div className="why-inner">
        <m.header
          className="why-header"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={fadeUp}
        >
          <h2>Why Choose ABL Construction Limited</h2>
          <p>
            Partner with a team that prioritizes quality, reliability, and long-term value for every
            project.
          </p>
        </m.header>

        <m.div
          className="why-grid"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={staggerContainer}
        >
          {reasons.map((reason, index) => (
            <m.article
              className="why-card"
              key={reason.title}
              variants={staggerItem}
              whileHover={{ y: -3 }}
              transition={{ type: 'spring', stiffness: 420, damping: 30 }}
            >
              <div className="why-number" aria-hidden="true">
                {String(index + 1).padStart(2, '0')}
              </div>
              <div className="why-content">
                <h3>{reason.title}</h3>
                <p>{reason.description}</p>
              </div>
            </m.article>
          ))}
        </m.div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
